export default "__VITE_ASSET__DsUP1b02__"